// removed by extract-text-webpack-plugin
module.exports = {"message":"message__3GWlH","small":"small__1RGXn","logo":"logo__NJ_DN"};


//////////////////
// WEBPACK FOOTER
// ./routes/notfound/style.less
// module id = iGSl
// module chunks = 0